// Owner builds default to the backend. The demo mode is retained only for the
// explicitly configured local fixture artifact used by browser evidence.
export const dataMode =
  import.meta.env.MODE !== "test" && import.meta.env.VITE_DATA_MODE === "demo" ? "demo" : "api";
export const isDemoMode: boolean = dataMode === "demo";

export const firebaseAuthEmulatorUrl = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_URL?.trim();

export const firebaseConfigurationReady = Boolean(
  import.meta.env.VITE_FIREBASE_API_KEY &&
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN &&
    import.meta.env.VITE_FIREBASE_PROJECT_ID &&
    import.meta.env.VITE_FIREBASE_APP_ID,
);
